import { SCREENSHOT_DATA } from './constants';

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Simplified function for direct imports - no path building needed
export const getAllScreenshots = () => {
  // Return the directly imported images - they're already ready to use
  return SCREENSHOT_DATA.images;
};

// Keep these for compatibility if needed elsewhere
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

export const preloadAllImages = async (imagePaths) => {
  try {
    await Promise.all(imagePaths.map(preloadImage));
    return true;
  } catch (error) {
    console.warn('Some images failed to preload:', error);
    return false;
  }
};

// Rest of your existing helper functions...
export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
};

export const validateForm = (formData, rules) => {
  const errors = {};
  
  Object.keys(rules).forEach(field => {
    const rule = rules[field];
    const value = formData[field];
    
    if (rule.required && (!value || !value.trim())) {
      errors[field] = `${field} is required`;
      return;
    }
    
    if (value && rule.minLength && value.trim().length < rule.minLength) {
      errors[field] = `${field} must be at least ${rule.minLength} characters`;
      return;
    }
    
    if (value && rule.maxLength && value.trim().length > rule.maxLength) {
      errors[field] = `${field} must not exceed ${rule.maxLength} characters`;
      return;
    }
    
    if (value && rule.pattern && !rule.pattern.test(value)) {
      errors[field] = rule.message || `${field} format is invalid`;
    }
  });
  
  return errors;
};

export const sanitizeInput = (input) => {
  return input.trim().replace(/[<>]/g, '');
};